module.exports = __webpack_public_path__ + "static/media/tra_imp_pro_veh.4601cfe8.png";